<template>
  <div class="order sale">
    <search :search-obj-list="search"
            :search-obj-type="false"
            :newStrType="false"
            @toNew="showNewDrawer"
            @reSearch="reSearch"
            :export-type="false"
            ref="search">
    </search>
    <div class="order-table">
      <div class="order-main-header">
        <el-tabs v-model="qxTable.searchObj.status" @tab-click="tableFlagAdd">
          <el-tab-pane :key="item.NAME"
                       :name="String(item.CODE)"
                       v-for="item in tabValueList">
            <span slot="label">{{ item.NAME }}</span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- <TableFilterPopover :tableSplitFields.sync="tableSplitFields"
                          :tableItems="tableItems"
                          :tableName="$options.name"
                          :tableKey.sync="tableKey"
                          :tabsActiveName="qxTable.searchObj.status"
                          ref="TableFilterPopover"/> -->
      <qx-table :qx-table="qxTable"
                @updateTable="updateTable"
                ref="qxTable">
        <template slot="table" slot-scope="data">
          <el-table :data="data.table" fit show-overflow-tooltip border
                    :row-class-name="tableRowClassName" :key="tableKey">
            <el-table-column label="序号" width="60" fixed="left">
              <template slot-scope="scope">
                {{
                  data.page.pageNum > 0 ? ((data.page.pageNum - 1)
                    * data.page.pageSize) + (scope.$index += 1) : scope.$index += 1
                }}
              </template>
            </el-table-column>
            <el-table-column v-for="item in tableSplitFieldsShow"
                             :label="item.label" :prop="item.prop" :key="item.prop"
                             :width="item.width" :fixed="item.fixed">
              <template slot-scope="scope">
                <template v-if="item.prop==='status'">
                  <span>{{ getStatus(scope.row.status) }}</span>
                </template>
                <template v-else-if="item.prop==='goodsNo'">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.custGoodsNo">
                    <div slot="content">
                      <div v-if="scope.row.custGoodsNo">
                        编号：{{ scope.row.custGoodsNo }}
                      </div>
                      <div v-if="scope.row.custColorName">
                        色号：{{ scope.row.custColorName }}
                      </div>
                      <div v-if="scope.row.modelNumber">
                        款号：{{ scope.row.modelNumber }}
                      </div>
                    </div>
                    <span v-if="scope.row.goodsInfo">
                      {{ scope.row.goodsInfo.goodsNo }}
                    </span>
                  </el-tooltip>
                  <span v-else>
                    {{ scope.row.goodsInfo.goodsNo }}
                  </span>
                </template>
                <template v-else-if="item.prop==='saleOrderNo'">
                  <div>
                    {{ scope.row.saleOrderNo }}
                  </div>
                  <div>
                    {{ scope.row.custOrderNo }}
                  </div>
                </template>
                <template v-else-if="item.prop==='mainQuantity'">
                  <span v-if="scope.row.goodsInfo">
                    {{ scope.row.goodsInfo.mainQuantity }}{{ scope.row.goodsInfo.mainQuantityUnit }}
                  </span>
                </template>
                <template v-else-if="item.prop==='deliveryQuantity'">
                  <span>
                    {{ getDeliveryQuantity(scope.row) }}
                  </span>
                </template>
                <template v-else-if="item.prop==='deliveryTime'">
                  <span v-if="scope.row.goodsInfo">
                    {{ getDistantTime(scope.row.goodsInfo) }}
                  </span>
                </template>
                <span v-else>
                  {{ scope.row[item.prop] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100px">
              <template slot-scope="scope">
                <div class="table-operator">
                  <i class="el-icon-third-chakan" title="查看" @click="details(scope.row,scope.$index)"/>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </qx-table>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 销售订单
 * @Author: 菩萨蛮
 * @Date: 2021/3/29 2:53 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

import SearchMixins from '@/mixins/order/SearchMixins';
import QxTable from '../../mixins/order/common/QxTable';
import Order from '../../mixins/order/common/Order';
import SaleOrder from '../../bean/order/SaleOrder';
import qs from 'qs';
import calculate from '../../plugins/calculate';
import TableFilterMixins from '../../mixins/order/common/TableFilterMixins';

export default {
  name: 'SaleOrder',
  mixins: [QxTable, Order, SearchMixins, TableFilterMixins],
  qx: {
    pageType: 'table',
    order: {
      ...SaleOrder
    }
  },
  data() {
    return {
      tabValueList: Object.values(this.CONSTANT.STATE_SALE_ORDER),
      qxTable: {
        url: '/sales/sale_order',
        searchObj: {
          status: '2,3'
        }
      },
      orderUrl: 'sale-order',
      tableSummary: {
        sumMainQuantity: '',
        sumSlaveQuantity: '',
        sumSurchargeFee: '',
        sumTotalPrice: '',
      },
      currentIndex: -1,
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex === this.currentIndex) {
        return 'row-active';
      }
      return '';
    },
    details(row,index) {
      this.currentIndex = index;
      this.$router.push(`/detail-${this.orderUrl}/${row.id}`);
    },
    async tableFlagAdd() {
      this.qxTable.updateFlag = this.qxTable.updateFlag + 1;
    },
    getDeliveryQuantity(row) {
      if ([2, 3, 6].includes(row.status)) {
        return `${row.shipmentCount || 0}`;
      }
      return `${row.shipmentCount || 0}(${row.unShipmentCount || 0}待发货)`;
    },
    getStatus(status) {
      if ([2, 3].includes(status)) {
        return '备货中';
      }
      if ([4].includes(status)) {
        return '发货中';
      }
      if ([6].includes(status)) {
        return '已完成';
      }
      return '';
    },
    getDistantTime(row) {
      if(row.deliveryTimeList) {
        let farTime = '1970-01-01';
        row.deliveryTimeList.forEach(e => {
          if(e.time) {
            let t1 = new Date(e.time);
            let t2 = new Date(farTime);
            if (t1 > t2) {
              farTime = e.time;
            }
          } else {
            farTime = '无';
          }
        });
        return farTime;
      }
      return '无';
    },
  }
};
</script>

<style lang="scss" scoped>
.send-dialog-div{
  margin-bottom: 5px
}
::v-deep ::-webkit-scrollbar {
    width: 10px !important;
    height: 10px !important;
}
::v-deep ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border-style: dashed;
    border-color: transparent;
    border-width: 3px;
    background-color: #a8a8a8;
    background-clip: padding-box;
}
::v-deep ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
::v-deep .el-table__fixed-right-patch {
    width: 15px !important;
    background-color: #e9edf0;
}
::v-deep .el-table__fixed-body-wrapper {
    max-height: calc(100vh - 380px);
    overflow-y: hidden;
}
::v-deep .el-table__fixed-right {
    right: 10px;
}
</style>
